import { css } from "@emotion/react"
import { Heading } from "@planningcenter/doxy-web"
import { BREAKPOINTS } from "source/shared/hooks/useWindowDimensions"
import { FREQUENCY_TYPE_TO_LABELS } from "../constants"
import { useDonationFormContext } from "../hooks/useDonationFormContext"
import { useMediaQuery } from "source/giving/hooks/useMediaQuery"
import { FrequencyTypeButton } from "./FrequencyTypeButton"
import { HorizontalItemScroller } from "source/giving/components/HorizontalItemScroller"
import { FrequencySummary } from "./FrequencySummary"
import { Frequency, FrequencyType } from "../types"
import { FrequencyEditable } from "./FrequencyEditable"

type FrequencySelectorProps = {
  frequency: Frequency
  editExpanded: boolean
}
export function FrequencySelector({
  frequency,
  editExpanded,
}: FrequencySelectorProps) {
  const { config, dispatch } = useDonationFormContext()

  const selectType = (type: FrequencyType) =>
    dispatch({
      type: "SET_FREQUENCY_TYPE",
      payload: type,
      frequencies: config.frequencies,
    })

  return (
    <div>
      <Heading level={3} text="Frequency" />
      <FrequencyOptionContainer>
        {config.frequencies.map((configFrequency) => (
          <FrequencyTypeButton
            key={configFrequency.type}
            active={frequency.type === configFrequency.type}
            onClick={() => selectType(configFrequency.type)}
            data-testid={`frequency-type-${configFrequency.type}`}
          >
            {FREQUENCY_TYPE_TO_LABELS[configFrequency.type]}
          </FrequencyTypeButton>
        ))}
      </FrequencyOptionContainer>
      {frequency.type !== "once" && (
        <div
          className="py-1 px-2 br-8p gc-tint9 mt-2"
          data-testid="frequency-details"
        >
          {editExpanded && <FrequencyEditable {...{ frequency }} />}
          {!editExpanded && <FrequencySummary {...{ frequency }} />}
        </div>
      )}
    </div>
  )
}

function FrequencyOptionContainer({ children }: { children: React.ReactNode }) {
  const isMobile = useMediaQuery(`(max-width: ${BREAKPOINTS.MD - 1}px)`)

  return isMobile ? (
    <HorizontalItemScroller className="mt-2">{children}</HorizontalItemScroller>
  ) : (
    <div
      className="mt-2 d-f g-1 fw-w"
      css={css`
        > * {
          flex: 1 1 calc(33% - 1rem); // 33% width without gap
        }
      `}
    >
      {children}
    </div>
  )
}
